export const ORIENTATIONS = {
  X: 'x-axis',
  Y: 'y-axis',
  CENTER: 'center',
};
